import { motion } from "framer-motion";

const DaasVendor = ({ scrollToForm, activeTab, setActiveTab }) => {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10 space-y-10">

        {/* Hero Section */}
        <motion.section
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex flex-col items-center text-center"
        >
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4">
            On-Demand <span className="text-blue-600">Drone Services</span> Across India
          </h1>

          <p className="text-base md:text-lg text-gray-600 max-w-2xl mb-6">
            Connect with <span className="font-semibold">DGCA-Certified Drone Pilots</span>
            & Fleet Operators. From agriculture to inspections and events –
            DronePlanet is your trusted Drone-as-a-Service (DaaS) marketplace.
          </p>

          {/* <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToForm}
            className="px-8 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold shadow-md"
          >
            Get Started
          </motion.button> */}
        </motion.section>

        {/* Services Section */}
        <section>
          <div className="text-center mb-8">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-2xl sm:text-3xl font-bold text-gray-800"
            >
              Our Reach & Services
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-gray-600 mt-2 text-base md:text-lg"
            >
              Delivering drone-powered solutions across industries and geographies
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            {/* Services Offered */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="bg-white shadow-md rounded-xl p-6"
            >
              <h3 className="text-xl font-semibold text-green-700 mb-4">
                Services We Offer
              </h3>

              <ul className="space-y-2 text-gray-700 text-base">
                <li>🚜 Agricultural Survey</li>
                <li>🏗️ Infrastructure Inspection</li>
                <li>🎥 Event Coverage</li>
                <li>🚨 Emergency Response</li>
              </ul>
            </motion.div>

            {/* States Covered */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="bg-white shadow-md rounded-xl p-6"
            >
              <h3 className="text-xl font-semibold text-green-700 mb-4">
                States We Serve
              </h3>

              <ul className="grid grid-cols-2 gap-y-2 text-gray-700 text-base">
                <li>📍 Maharashtra</li>
                <li>📍 Karnataka</li>
                <li>📍 Tamil Nadu</li>
                <li>📍 Uttar Pradesh</li>
                <li>📍 Gujarat</li>
                <li>📍 Punjab</li>
                <li>📍 Rajasthan</li>
                <li>📍 And More...</li>
              </ul>
            </motion.div>

          </div>
        </section>

        {/* Enterprise vs Freelancers */}
        <div className="container mx-auto px-6 py-6">
  <div className="flex flex-col md:flex-row gap-6">

    {/* Service Providers */}
    <motion.div
      whileHover={{ scale: 1.05 }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className={`flex-1 bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-all duration-300 ${
        activeTab === "enterprises" ? "border-2 border-green-500" : ""
      }`}
      onClick={() => setActiveTab("enterprises")}
    >
      <div className="h-40 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20drone%20company%20team%20with%20enterprise%20grade%20drones%2C%20business%20setting%2C%20corporate%20team%20working%20with%20advanced%20drone%20technology%2C%20clean%20modern%20office%20background%2C%20high-tech%20equipment%2C%20professional%20atmosphere&width=600&height=300&seq=2&orientation=landscape"
          alt="Enterprise Drone Services"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-800 mb-1">
          For Service Providers
        </h3>

        <h4 className="text-base text-green-600 mb-3">
          Monetize Your Drone Fleet
        </h4>

        <div className="w-12 h-1 bg-green-500 mb-4"></div>

        <p className="text-gray-600 mb-4 text-sm">
          Maximize Your Drone's ROI. List Your Services to India's Largest
          Network of Clients.
        </p>

        <h5 className="font-semibold text-gray-800 mb-3">Key Features:</h5>

        <ul className="space-y-2 text-sm">
          <li>✅ Fleet Monetization: Earn per-project fees for idle drones.</li>
          <li>✅ Compliance Assurance: DGCA/Flight Permit integration.</li>
          <li>✅ Client Matching: AI-driven alignment with high-value projects.</li>
          <li>✅ Payment Security: Escrow-based transactions.</li>
        </ul>

        <p className="mt-4 text-gray-600 text-sm">
          Requirements: DGCA RPL/SUAS, Drone Registration (Digital Sky), GSTIN.
        </p>
      </div>
    </motion.div>

    {/* Service Seekers */}
    <motion.div
      whileHover={{ scale: 1.05 }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
      className={`flex-1 bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-all duration-300 ${
        activeTab === "freelancers" ? "border-2 border-green-500" : ""
      }`}
      onClick={() => setActiveTab("freelancers")}
    >
      <div className="h-40 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=freelance%20drone%20pilot%20operating%20advanced%20drone%20equipment%2C%20creative%20professional%20with%20camera%20drone%2C%20outdoor%20setting%2C%20beautiful%20landscape%2C%20action%20shot%20of%20pilot%20with%20controller%2C%20passionate%20individual%20with%20technical%20gear&width=600&height=300&seq=3&orientation=landscape"
          alt="Freelance Drone Pilot"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-800 mb-1">
          For Service Seekers
        </h3>

        <h4 className="text-base text-green-600 mb-3">
          Book Certified Drone Services in 2 Clicks
        </h4>

        <div className="w-12 h-1 bg-green-500 mb-4"></div>

        <p className="text-gray-600 mb-4 text-sm">
          Source Fully Compliant Drone Services with Guaranteed Quality &
          Insurance.
        </p>

        <h5 className="font-semibold text-gray-800 mb-3">Use Cases:</h5>

        <ul className="space-y-2 text-sm">
          <li>✅ Agriculture: Crop health analysis, land mapping.</li>
          <li>✅ Infrastructure: Bridge/pipeline inspections, solar farm audits.</li>
          <li>✅ Government: Disaster management, surveillance.</li>
          <li>✅ Media: Aerial photography, live event streaming.</li>
        </ul>

        <p className="mt-4 text-gray-600 text-sm">
          Process: Submit Scope → Receive Bids → Select & Deploy. <br />
          Pricing: ₹2,500 – ₹15,000/day (varies by drone). <br />
          Insurance: Included (DGCA-compliant).
        </p>
      </div>
    </motion.div>

  </div>
</div>

        {/* Compliance Section */}
        <section>

          <div className="text-center mb-6">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-2xl font-bold text-gray-800"
            >
              India-Specific Compliance
            </motion.h2>

            <div className="w-20 h-1 bg-green-500 mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

            {[
              {
                icon: "fa-shield-alt",
                title: "DGCA Compliance",
                desc: "All operations adhere to Digital Sky NPNT mandates",
              },
              {
                icon: "fa-user-lock",
                title: "Verified Pilots",
                desc: "Aadhaar-verified pilots with encrypted geofencing",
              },
              {
                icon: "fa-file-contract",
                title: "Insurance Coverage",
                desc: "₹10L+ third-party coverage included",
              },
              {
                icon: "fa-rupee-sign",
                title: "Transparent Pricing",
                desc: "Clear hourly/day rates with no hidden charges",
              },
            ].map((item, i) => (
              <motion.div 
                          key={i}
                          initial={{ opacity: 0, y: 40 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.6, delay: i * 0.2 }}
                          whileHover={{ scale: 1.05 }}
                          className="bg-white shadow-md rounded-xl p-6 text-center"
                        >
                          <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                            <i className={`fas ${item.icon} text-green-600 text-xl`}></i>
                          </div>
                          <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                          <p className="text-gray-600 text-sm">{item.desc}</p>
                        </motion.div>
            ))}

          </div>
        </section>

      </div>
    </div>
  );
};

export default DaasVendor;